<template>
    <div class="row" v-if="isAvailableForView">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Stages</div>
                        <a href="/master-admin/settings/status/create" class="btn btn--outline-primary btn--middle">+
                            Add New</a>

                    </div>
                    <div class="mt-4">
                        <div id="accordion" class="accordion">
                            <div class="accordion--card">
                                <button class="accordion--btn accordion--btn-secondary-bg" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    In Process
                                </button>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                                    <div class="">
                                        <div class="table-holder table-responsive">
                                            <div class="table">
                                                <draggable v-model="pendingStatuses" @end="onDragEnd('pending')">
                                                    <div
                                                        class="pt-3 pb-3"
                                                        v-for="(status, index) in pendingStatuses"
                                                        :key="status.id"
                                                        style="width: 100%; align-items: center; display: flex; border-bottom: 1px solid #ccc"
                                                    >
                                                        <div style="width: 3rem;">
                                                            <div class="lines-block">
                                                                <div class="line"></div>
                                                                <div class="line"></div>
                                                            </div>
                                                        </div>
                                                        <div style="width:1.5rem;" class="pr-2">
                                                            <b >{{ index + 1 }}</b>
                                                        </div>
                                                        <div
                                                            class="pl-2 pr-2"
                                                        >{{ status.name }}</div>
                                                        <div class="text-right" style="margin-left: auto;">
                                                            <div class="action-block">
                                                                <a :href="`/master-admin/settings/status/${status.id}/update`"
                                                                   class="edit-link"><img src="/img/svg/icons-pen.svg"
                                                                                          alt=""></a>
                                                                <button class="delete-link"
                                                                        @click="showModal(status.id)"
                                                                ><img src="/img/svg/on.svg" alt="delete"></button>
                                                                <ActionModal confirm-text="Yes" reject-text="No"
                                                                             :modalId="getModalId(status.id)"
                                                                             @confirm="deleteStatus(status.id)">
                                                                    <template #body>
                                                                        <div class="text-center mb-4">
                                                                            <h4>
                                                                                Are you sure you want <br> to delete this
                                                                                item?
                                                                            </h4>
                                                                        </div>
                                                                    </template>
                                                                </ActionModal>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </draggable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion--card">
                                <button class="accordion--btn accordion--btn-green-bg" data-toggle="collapse"
                                        data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Active
                                </button>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                    <div class="">
                                        <div class="table-holder table-responsive">
                                            <div class="table">
                                                <draggable v-model="activeStatuses" @end="onDragEnd('active')">
                                                    <div
                                                        class="pt-3 pb-3"
                                                        v-for="(status, index) in activeStatuses"
                                                        :key="status.id"
                                                        style="width: 100%; align-items: center; display: flex; border-bottom: 1px solid #ccc"
                                                    >
                                                        <div style="width: 3rem;">
                                                            <div class="lines-block">
                                                                <div class="line"></div>
                                                                <div class="line"></div>
                                                            </div>
                                                        </div>
                                                        <div class="pr-2 " style="width:1.5rem;">
                                                            <b>{{ index + 1 + pendingStatuses.length }}</b>
                                                        </div>
                                                        <div class="pl-2 pr-2">{{ status.name }}</div>
                                                        <div class="text-right" style="margin-left: auto;">
                                                            <div class="action-block">
                                                                <a :href="`/master-admin/settings/status/${status.id}/update`"
                                                                   class="edit-link"><img src="/img/svg/icons-pen.svg"
                                                                                          alt=""></a>
                                                                <button class="delete-link"
                                                                        @click="showDeleteModal(status.id)"
                                                                ><img src="/img/svg/on.svg" alt="delete"></button>
                                                                <ActionModal confirm-text="Yes" reject-text="No"
                                                                             :modalId="getDeleteModalId(status.id)"
                                                                             @confirm="deleteStatus(status.id)">
                                                                    <template #body>
                                                                        <div class="text-center mb-4">
                                                                            <h4>
                                                                                Are you sure you want <br> to delete this
                                                                                item?
                                                                            </h4>
                                                                        </div>
                                                                    </template>
                                                                </ActionModal>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </draggable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import StatusService from "./services/StatusService";
import draggable from 'vuedraggable'
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'StatusList',
    components: {ActionModal, draggable},
    props: {
        isAvailableForView: {
            type: Boolean,
            required: true
        },
        statusList: {
            type: Array
        }
    },
    mixins: [ModalHandler],

    data() {
        return {
            activeStatuses: [],
            loading: true,
            pendingStatuses: [],
            statuses: this.statusList
        }
    },
    methods: {
        onDragEnd(arr) {
            const newSequencePending = this.pendingStatuses.map(item => item.id)
            const newSequenceActive = this.activeStatuses.map(item => item.id)

            this.sendPositionToBackend(newSequencePending, newSequenceActive)
        },
        async deleteStatus(id) {
            this.$showLoadingMessage()
            this.statuses = this.statuses.filter((status) => status.id !== id)
            try {
                await StatusService.delete(id)
                this.$showSuccessMessageDelete();
                this.sortStatus()
            } catch (error) {
                this.$showErrorMessage('The stage item was not deleted. Please try again');
            }
        },
        async sendPositionToBackend(newSequencePending, newSequenceActive) {
            this.$showLoadingMessage()
            try {
                await StatusService.updateStagePosition(newSequencePending, newSequenceActive)
                this.$showSuccessMessage('The stage was replaced')
            } catch (e) {
                this.$showErrorMessage('The new stage position has not been updated')
            }

        },
        sortStatus() {
            this.activeStatuses = this.statuses.filter((item) => item.status === 'active')
            this.pendingStatuses = this.statuses.filter((item) => item.status === 'in_process')
            this.loading = false
        }
    },

    mounted() {
        this.sortStatus()
    }
}

</script>


<style scoped>

</style>
